import React from "react"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

import * as styles from "./bottomCta.module.scss"
import { Img } from "./Img"

type BottomCtaProps = {
  orderNum: string
  buttonText?: string
}

const handleClick = (buttonText: string) => {
  DLClickEventExtended({
    name: buttonText,
    eventAction: "Оформите Халву и получите меся",
    placement: "promo",
  })
  scrollToPersonalForm()
}

export const BottomCta = ({ orderNum, buttonText = "Оформить карту" }: BottomCtaProps) => (
  <section className={styles.section} id="promo" data-exclude={orderNum}>
    <Container>
      <div className={styles.secondContainer}>
        <div className={styles.wrapper}>
          <Img alt="card halva" className={styles.img} />
          <div className={styles.textBlock}>
            <h2 className={styles.title}>Оформите карту «Халва»</h2>
            <p className={styles.descr}>
              Получите подписку «Халва.Десятка» на&nbsp;месяц в&nbsp;подарок!
            </p>
          </div>
          <Button className={styles.btn} disableRipple onClick={() => handleClick(buttonText)}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Container>
  </section>
)
